import { render, staticRenderFns } from "./entityAccessories.vue?vue&type=template&id=3129d1da&scoped=true&"
import script from "./entityAccessories.vue?vue&type=script&lang=ts&"
export * from "./entityAccessories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3129d1da",
  null
  
)

export default component.exports